(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.controller('PasswordRecoveryController', function ($scope, $state, screenBlockService, authenticationService,accountManagementService,tenantSetupService) {

        $scope.requestSent = false;

        //Invoke
        (function(){
            tenantSetupService.getSettings().then(function(response){
                $scope.tenantId = response.data.TenantId;
            },function(errorResponse){
                console.log('Error Getting Tenant Settings');
            });
        })();

        $scope.initForgottenPassword = function(form){

            if(form.$valid) {
                screenBlockService.blockScreen();

                //How to get Tenant?
                accountManagementService.initForgotPassword(form.username.$modelValue, $scope.tenantId).then(function (response) {

                    $scope.requestSent = true;
                    console.log('initForgotPassword-Result', response.data);
                    screenBlockService.clearScreen();

                }, function (errorResponse) {

                    console.log('initForgotPassword-Error', errorResponse);
                    screenBlockService.clearScreen();

                });
            }
        }

    });
})(window.angular);